export enum Fallback_Type_Constants {
  SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NO_ACTIVE_INTERNET = 'NO_ACTIVE_INTERNET',
  CONTENT_NOT_AVAILABLE = 'CONTENT_NOT_AVAILABLE',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  CONTENT_NOT_AVAILABLE_REGION = 'CONTENT_NOT_AVAILABLE_REGION',
  FEATURE_NOT_AVAILABLE = 'FEATURE_NOT_AVAILABLE'
}
